import { array, boolean, enum as zodEnum, object, optional, string } from 'zod';

import { ANSWER_REVEAL_MODE } from '@/shared/utils/answerRevealMode';

export const BuildQuizSetOptionSchema = object({
  isPublic: boolean(),
  isAllowPass: boolean(),
  answerRevealMode: zodEnum([
    ANSWER_REVEAL_MODE.ALWAYS,
    ANSWER_REVEAL_MODE.INCORRECT_ONLY,
    ANSWER_REVEAL_MODE.NEVER,
  ]),
  isNextQuizsetAvailable: boolean(),
  nextQuizsetId: optional(string()),
  aiTranslationLanguages: array(string()),
  isAiTranslationEnabled: boolean(),
  aiTutorEnabled: boolean(),
  aiTutor: optional(
    object({
      id: string(),
      name: string(),
      avatarSrc: string(),
      introduction: string(),
    }),
  ),
});

export const getBuildQuizSetOptionSchema = () => {
  return BuildQuizSetOptionSchema;
};
